import { isPdfPasswordProtect } from './helper';

export const validateFilesForUpload = async ({
  files,
  accept = 'application/pdf',
  maxSize = 500 * 1024 * 1024
}) => {
  const errorList = [];
  const validFiles = [];

  for (const item of files || []) {
    const isPdfValidation = accept === 'application/pdf';
    const isProtected = isPdfValidation ? await isPdfPasswordProtect(item) : false;

    if (item.size === 0) {
      errorList.push({
        fileName: item?.name,
        fileSize: item.size
      });
      continue;
    }

    if (item.size > maxSize) {
      errorList.push({
        fileName: item?.name,
        fileSize: item.size,
        isFileLarge: true,
        maxSize
      });
      continue;
    }

    if (isPdfValidation && item.type !== 'application/pdf') {
      const fileName = (item?.name || '').toLowerCase();
      const isPdfByName = fileName.endsWith('.pdf');
      if (isPdfByName && !item.type) {
        validFiles.push(item);
        continue;
      }
      errorList.push({
        fileName: item?.name,
        fileTypeError: true
      });
      continue;
    }

    if (isPdfValidation && isProtected) {
      errorList.push({
        fileName: item?.name,
        isPasswordProtected: true
      });
      continue;
    }

    validFiles.push(item);
  }

  return { validFiles, errorList };
};
